import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { EmailPdfWizardContainer } from './email-pdf-wizard-container';

export interface EmailPdfSidebarData {
  reportId?: string;
  reportName: string;
  exportedReportId?: string;
}

interface EmailPdfSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  data: EmailPdfSidebarData;
}

export const EmailPdfSidebar = ({ isOpen, onClose, data }: EmailPdfSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        <FormattedMessage id="predict.actions.email_pdf" defaultMessage="Email PDF report" />
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <EmailPdfWizardContainer
      onClose={onClose}
      reportId={data.reportId}
      reportName={data.reportName}
      exportedReportId={data.exportedReportId}
    />
  </Sidebar>
);
